<template>
  <div>
    <div class="border rounded p-1 mb-2 custom-container">
      <div class="col-lg-12 mb-1">
        <div class="mb-1">{{ $t('dashboard-aggregate.period') }}</div>
        <div class="d-flex justify-content-center">
          <button type="button"
                  class="btn btn-outline-primary mx-2"
                  :class="{ active: selectedMonth === 'this_month' }"
                  @click="choose_month('this_month')">
            {{ $t('dashboard-aggregate.this-month') }}
          </button>
          <button type="button"
                  class="btn btn-outline-primary mx-2"
                  :class="{ active: selectedMonth === 'last_month' }"
                  @click="choose_month('last_month')">
            {{ $t('dashboard-aggregate.last-month') }}
          </button>
          <button type="button"
                  class="btn btn-outline-primary mx-2"
                  :class="{ active: selectedMonth === 'two_months_ago' }"
                  @click="choose_month('two_months_ago')">
            {{ $t('dashboard-aggregate.2mos-ago') }}
          </button>
          <button type="button"
                  class="btn btn-outline-primary mx-2"
                  :class="{ active: selectedMonth === 'three_months_ago' }"
                  @click="choose_month('three_months_ago')">
            {{ $t('dashboard-aggregate.3mos-ago') }}
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-12 d-flex justify-content-start">
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.reservations-received')">
          {{ $t('dashboard-aggregate.reservations-received') }}<br />
          {{ monthlyData.reservation_count === 0 ? '---' : monthlyData.reservation_count }}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.exclusions')">
          {{ $t('dashboard-aggregate.exclusions') }}<br />
          {{ monthlyData.exclusion_count === 0 ? '---' : monthlyData.exclusion_count }}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.exclusion-rate')">
          {{ $t('dashboard-aggregate.exclusion-rate') }}<br />
          {{ monthlyData.exclusion_rate === 0 ? '---' : monthlyData.exclusion_rate + '%'}}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.emailable-reservation')">
          {{ $t('dashboard-aggregate.emailable-reservation') }}<br />
          {{ monthlyData.sendable_count === 0 ? '---' : monthlyData.sendable_count }}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.number-of-sign-ups')">
          {{ $t('dashboard-aggregate.number-of-sign-ups') }}<br />
          {{ monthlyData.registration_count === 0 ? '---' : monthlyData.registration_count }}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.average-sign-up-rate')">
          {{ $t('dashboard-aggregate.average-sign-up-rate') }}<br />
          {{ monthlyData.average_registration_rate === 0 ? '---' : monthlyData.average_registration_rate　+ '%' }}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.url-registrations')">
          {{ $t('dashboard-aggregate.url-registrations') }}<br />
          {{ monthlyData.registration_url_count === 0 ? '---' : monthlyData.registration_url_count }}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 d-flex justify-content-start">
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.emails-sent')">
          {{ $t('dashboard-aggregate.emails-sent') }}<br />
          {{ monthlyData.email_sent_count === 0 ? '---' : monthlyData.email_sent_count }}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.smss-sent')">
          {{ $t('dashboard-aggregate.smss-sent') }}<br />
          {{ monthlyData.sms_sent_count === 0 ? '---' : monthlyData.sms_sent_count }}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.email-sign-ups')">
          {{ $t('dashboard-aggregate.email-sign-ups') }}<br />
          {{ monthlyData.email_registration_count === 0 ? '---' : monthlyData.email_registration_count }}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.sms-sign-ups')">
          {{ $t('dashboard-aggregate.sms-sign-ups') }}<br />
          {{ monthlyData.sms_registration_count === 0 ? '---' : monthlyData.sms_registration_count }}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.email-sign-up-rate')">
          {{ $t('dashboard-aggregate.email-sign-up-rate') }}<br />
          {{ monthlyData.email_average_registration_rate === 0 ? '---' : monthlyData.email_average_registration_rate + '%'}}
        </div>
        <div class="border rounded p-2 flex-fill data-box"
            :title="$t('aggregate-mouseover.sms-sign-up-rate')">
          {{ $t('dashboard-aggregate.sms-sign-up-rate') }}<br />
          {{ monthlyData.sms_average_registration_rate === 0 ? '---' : monthlyData.sms_average_registration_rate + '%'}}
        </div>
      </div>
    </div>

    <div class="d-flex col-12 mb-2">
      <div class="border rounded p-2 row mb-2 mr-2"
      :title="$t('aggregate-mouseover.radio-button-announce')">
        <label class="mb-0 mr-2">
          <input type="radio" name="switch" value="daily"
                :checked="selectedPeriodBtn === 'daily'"
                @change="switchChart('daily')">
          <i class="ml-1 mr-1 fas fa-chart-bar text-primary"></i>{{ $t('dashboard-aggregate.day-to-day') }}
        </label>
        <label class="mb-0">
          <input type="radio" name="switch" value="monthly"
                :checked="selectedPeriodBtn === 'monthly'"
                @change="switchChart('monthly')"
                @click="past_three_months">
          <i class="ml-1 mr-1 fas fa-chart-bar text-primary"></i>{{ $t('dashboard-aggregate.3mos-period') }}
        </label>
      </div>

      <button type="button"
              class="btn border rounded p-2 mb-2 download-button"
              @click="exportExcel">
        <i class="fas fa-download text-primary"></i>
        {{ $t('dashboard-aggregate.graph-data-output') }}
      </button>
    </div>

    <div class="charts-wrap">
      <canvas
        ref="mainChart"
        :class="selectedPeriodBtn === 'daily' ? 'chart-big' : 'chart-small'"
        :height="selectedPeriodBtn === 'daily' ? 400 : 400">
      </canvas>

      <canvas v-if="selectedPeriodBtn === 'monthly'"
              ref="subChart"
              class="chart-small"
              height="200">
      </canvas>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import moment from 'moment'
import aggregateApi from '@/api/aggregate'
import { mapGetters ,mapActions } from "vuex";

const toNullIfZero = v => (v === 0 ? null : v);
const calcY1Max = values => {
  const rawMax  = Math.max(...values, 0);
  const doubled = rawMax * 2;
  return Math.max(10, Math.ceil(doubled / 10) * 10);
};

const showValuesPlugin = {
  afterDatasetsDraw (chart) {
    const ctx = chart.ctx
    ctx.save()
    ctx.font = '11px sans-serif'
    ctx.fillStyle = '#000'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'bottom'

    chart.data.datasets.forEach((ds, iDs) => {
      if (!chart.isDatasetVisible(iDs)) return
      const meta = chart.getDatasetMeta(iDs)
      meta.data.forEach((el, i) => {
        let val = ds.data[i];
        if (val === null || val === undefined) return;
        if (ds.yAxisID === 'y2' && val > 100) return;
        if (val === 0) return;
        if (ds.yAxisID === 'y2') {
          val += '%';
          const { x, y } = el.tooltipPosition();
          ctx.fillText(val, x, y - 3);
        } else {
          const { x, y } = el.tooltipPosition();
          ctx.fillText(val, x, y + 5);
        }
      });
    });
    ctx.restore()
  }
};

Chart.plugins.register(showValuesPlugin)

export default {
  computed: {
    ...mapGetters("dashboard", ["facility"]),
  },
  data () {
    return {
      selectedMonth: 'this_month',
      selectedPeriodBtn: 'daily',
      mainInstance: null,
      subInstance: null,
      filters: {},
      monthlyData: [],
      dailyData: [],
      pastThreeMonths: [],
    };
  },
  mounted () {
    this.updateActiveMenu("aggregate");
    this.pms_code = this.facility.slug_name;
    this.choose_month(this.selectedMonth);
    this.selectedPeriodBtn = 'daily';
    this.redrawCharts();
  },

  methods: {
    ...mapActions("dashboard", ["updateActiveMenu"]),
    async choose_month(choose_month) {
      try {
      const response = await aggregateApi.chooseMonth(choose_month, this.pms_code);
      this.monthlyData = response.data.monthly_data;
      this.dailyData = response.data.daily_data;
      this.selectedMonth = choose_month;
      this.redrawCharts();
      } catch (e) {
        console.error(e)
        this.$toast.error(this.$t('dashboard-common.error-generic'), { position: 'top', duration: 0 })
      }
    },

    async past_three_months() {
      try {
      const response = await aggregateApi.pastThreeMonths(this.pms_code);
      this.pastThreeMonths = response.data.monthly_data;
      this.drawMonthly();
      } catch (e) {
        console.error(e)
        this.$toast.error(this.$t('dashboard-common.error-generic'), { position: 'top', duration: 0 })
      }
    },

    async exportExcel () {
      const params = {pms_code: this.pms_code};
      try {
        const res = await aggregateApi.download(params)
        const file = moment().format('YYYYMMDD')
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${file}_data.xlsx`
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        console.error(e)
        this.$toast.error(this.$t('dashboard-common.error-generic'), { position: 'top', duration: 0 })
      }
    },

    redrawCharts () {
      if (this.mainInstance) { this.mainInstance.destroy(); this.mainInstance = null }
      if (this.subInstance) { this.subInstance.destroy(); this.subInstance = null }

      this.$nextTick(() => {
        this.selectedPeriodBtn === 'daily' ? this.drawDaily() : this.drawMonthly()
      })
    },

    buildChart (ref, cfg, holder) {
      if (this[holder]) { this[holder].destroy(); this[holder] = null }
      this[holder] = new Chart(this.$refs[ref].getContext('2d'), cfg)
    },

    drawDaily () {
      const lbl = this.dailyData.map((item, index) => {
        return `${moment(item.date).format('DD')}${this.$t(`days.day${index + 1}`)}`;
        });
      const bar = this.dailyData.map(item => item.registration_count);
      const bar2 = this.dailyData.map(item => item.reservation_count);
      const line = this.dailyData.map(item => toNullIfZero(item.average_registration_rate));
      this.buildChart('mainChart',
                      this.barLineConfig(lbl, bar, line, true, bar2, 'dashboard-aggregate.sign-up-rate'),
                      'mainInstance')
      if (this.subInstance) { this.subInstance.destroy(); this.subInstance = null }
    },
    getMonthNames () {
      const monthNames = [
        this.$t('months.january'),
        this.$t('months.february'),
        this.$t('months.march'),
        this.$t('months.april'),
        this.$t('months.may'),
        this.$t('months.june'),
        this.$t('months.july'),
        this.$t('months.august'),
        this.$t('months.september'),
        this.$t('months.october'),
        this.$t('months.november'),
        this.$t('months.december'),
      ];
      const shortMonthNames = [
        'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.',
        'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'
      ];
      return this.$i18n.locale === 'en' ? shortMonthNames : monthNames;
    },
    drawMonthly () {
      const lbl = this.pastThreeMonths.map(item => {
        const monthIndex = moment(item.month).month();
        return this.getMonthNames()[monthIndex];
      });
      const bar = this.pastThreeMonths.map(item => item.registration_count);
      const line = this.pastThreeMonths.map(item => toNullIfZero(item.average_registration_rate));

      this.buildChart('mainChart',
                      this.barLineConfig(lbl, bar, line, false, null, 'dashboard-aggregate.average-sign-up-rate'),
                      'mainInstance')

      this.$nextTick(() => {
        this.buildChart('subChart', this.monthlySubConfig(), 'subInstance')
      })
    },


    barLineConfig(labels, barData, lineData, showXAxisLabel = false, reservationBarData = null, lineLabelKey = 'dashboard-aggregate.sign-up-rate') {
      const y1Max = calcY1Max(reservationBarData ? [...barData, ...reservationBarData] : barData);

      const y2Max = 100;
      const datasets = [
            {
              type        : 'line',
              label       : this.$t(lineLabelKey),
              data        : lineData,
              borderColor : 'rgba(74,92,142,1)',
              borderWidth : 4,
              yAxisID     : 'y2',
              fill        : false,
              tension     : 0,
              pointRadius : 2
            }
          ]
          if (reservationBarData) {
            datasets.push({
              label              : this.$t('dashboard-aggregate.reservations-received'),
              data               : reservationBarData,
              backgroundColor    : 'rgba(223,223,223,1)',
              borderColor        : 'rgba(223,223,223,1)',
              borderWidth        : 4,
              yAxisID            : 'y1',
              barPercentage      : 1,
              categoryPercentage : 0.7
            })
          }
          datasets.push({
            label              : this.$t('dashboard-aggregate.number-of-sign-ups'),
            data               : barData,
            backgroundColor    : 'rgba(232,197,195,1)',
            borderColor        : 'rgba(232,197,195,1)',
            borderWidth        : 4,
            yAxisID            : 'y1',
            barPercentage      : 1,
            categoryPercentage : 0.7
          })
      return {
        type: 'bar',
        data: {
          labels,
          datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
          display: true,
            labels: {
              fontSize: 13
            }
          },
          scales: {
            yAxes: [
              {
                id: 'y1',
                position: 'left',
                ticks: {
                  beginAtZero: true,
                  max: y1Max,
                  callback(value) {
                    return Number.isInteger(value) ? value : null;
                  }
                }
              },
              {
                id: 'y2',
                position: 'right',
                ticks: {
                  display: false,
                  beginAtZero: false,
                  min: -100,
                  max: y2Max,
                  callback(value) {
                    return (Number.isInteger(value) && value >= 0) ? value + '%' : ''
                  }
                },
                gridLines: { drawOnChartArea: false }
              }
            ],
            xAxes: [{
              gridLines: { display: false },
              scaleLabel: {
                display   : showXAxisLabel,
                labelString: this.$t('dashboard-aggregate.check-in-date'),
                fontSize  : 15,
                align     : 'center'
              }
            }]
          }
        }
      };
    },

    monthlySubConfig() {
      const barData  = this.pastThreeMonths.map(item => item.reservation_count);
      const lineData = this.pastThreeMonths.map(item => toNullIfZero(item.exclusion_rate));
      const y1Max = calcY1Max(barData);
      return {
        type: 'bar',
        data: {
          labels: this.pastThreeMonths.map(item => {
            const monthIndex = moment(item.month).month()
            return this.getMonthNames()[monthIndex]
          }),
          datasets: [
            {
              type        : 'line',
              label       : this.$t('dashboard-aggregate.exclusion-rate'),
              data        : lineData,
              borderColor : 'rgba(255,0,12,1)',
              borderWidth : 4,
              yAxisID     : 'y2',
              fill        : false,
              tension     : 0,
              pointRadius : 2            },
            {
              label              : this.$t('dashboard-aggregate.reservations-received'),
              data               : barData,
              backgroundColor    : 'rgba(223,223,223,1)',
              borderColor        : 'rgba(223,223,223,1)',
              borderWidth        : 4,
              barPercentage      : 1,
              categoryPercentage : 0.7,
              yAxisID            : 'y1'
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true,
            labels: {
              fontSize: 13
            }
          },
          scales: {
            yAxes: [
              {
                id: 'y1',
                position: 'left',
                ticks: {
                  beginAtZero: true,
                  max: y1Max,
                  callback(value) { return Number.isInteger(value) ? value : null }
                }
              },
              {
                id: 'y2',
                position: 'right',
                ticks: {
                  display: false,
                  beginAtZero: false,
                  min: -100,
                  max: 100,
                  callback(value) {
                    return (Number.isInteger(value) && value >= 0) ? value + '%' : ''
                  }
                },
                gridLines: { drawOnChartArea: false }
              }
            ],
            xAxes: [{ gridLines: { display: false } }]
          }
        }
      }
    },

    switchChart(periodBtn) {
      this.selectedPeriodBtn = periodBtn
      this.redrawCharts()
    }
  },

  watch: {
    '$i18n.locale': {
      immediate: false,
      handler() {
        this.redrawCharts()
      }
    }
  }
}
</script>

<style scoped>
.custom-container { max-width: 485px; width: 100%; }
.download-button { max-width: 180px; margin-right: 10px; }
.data-box {
  display: flex;
  flex-direction: column;
  max-width: 155px;
  min-width: 155px;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 0.4rem;
}
.charts-wrap { display: flex; flex-wrap: wrap; gap: 10px; }
.chart-big { justify-content: flex-start; max-width: 90%; max-height: 100%; }
.chart-small { justify-content: flex-start; max-width: 45%; max-height: 100%; }
</style>
